<template>
    <div class="Monitor">
        <div class="title">
            <span class="tt">监控视频</span>
            <span class="all" @click="checkAll" v-if="projectId==1||projectId==18">展开全部</span>
        </div>
        <div class="cont row-center">
            <div class="item" v-for="(item,index) in videoList" :class="{'full':item.isFull}">
                <!-- <img src="@/assets/img/firmImg.png" alt="" class="img"> -->
                <iframe :src="'https://local.vrmaker.vip:1443/webrtc/index.html?'+item.videoCode" v-if="refresh" frameborder="0" height="100%" width="100%"></iframe>
                <div class="inall" v-if="!item.isFull">
                    <span  @click="full(item,index)">
                        <img src="@/assets/img/whiteFull.png" alt="">全屏
                    </span>
                </div>
                <div v-else class="all" @click="full(item,index)">
                    <img src="@/assets/img/whiteFull.png" alt="">取消全屏
                </div>
            </div>
            <div class="item novideo" v-for="item in 4-videoList.length">
                <img src="@/assets/img/video.png" alt="">
            </div>
        </div>
        
    </div>
</template>

<script>
import { GetSecurityDevices, _getProjectCamera } from '../../api/power.js'
     export default {
         data(){
             return {
                isFull:false,
                videoList:[],
                refresh:true, // 视频刷新
             }
         },
         components:{
             
         },
         computed:{
            projectId(){
                return this.$store.getters.projectId
            },
         },
         mounted(){
             this.GetSecurityDevices()
             let _this = this
             this.timer = setInterval(()=>{
                _this.refresh = false
                _this.$nextTick(()=>{
                    _this.refresh = true
                })
             }, 1000 * 60 * 15)
         },
         destroyed(){
            if(this.timer){
                clearInterval(this.timer)
                this.timer = null
            }
         },
         watch: {
            "$store.state.project.currentProject.projectId"(n,o){
                this.GetSecurityDevices()
            }
         },
         methods:{
            checkAll(){
                if(this.projectId==1){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://chvideo.energydt.cn:7001/chvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }else if(this.projectId==18){
                    let name = this.$store.state.homeitem.user.realName;
                    let userimg = this.$store.state.homeitem.user.img;
                    window.open("http://jtvideo.energydt.cn:7001/jtvideo/index.html?name="+name+'&userimg='+userimg,"_blank");
                }
            },
            GetSecurityDevices(){
                GetSecurityDevices().then((res) => {
                    let monitorArr = [];
                    let id = 0;
                    res.data.data.devices.map((item, index) => {
                        if (item.device_class_name == "监控设备") {
                            monitorArr.push({
                                id: id++,
                                isFull:false,
                                videoName: item.device_name,
                                videoCode: JSON.parse(item.device_details).roomName,
                            });
                        }
                    });
                    this.videoList = monitorArr.filter((e,l)=>l<=3);
                });
            },
            full(item,index) {
                this.videoList[index].isFull = !this.videoList[index].isFull
            },
         }
     }
     </script>
<style lang="less" scoped>
    .Monitor{
        padding:10rem 12rem;
        .title{
            overflow: hidden;
            line-height: 32rem;
            margin-bottom: 5rem;
            .tt{
                font-size: 16rem;
                font-weight: bold;
            }
            .all{
                display: inline-block;  
                float: right;
                text-align: center;
                line-height: 32rem;
                width: 112rem;
                height: 32rem;
                color: #ffffff;
                background: #0D94FF;
                border-radius: 2rem;
                cursor: pointer;
            }
        }
        .cont{
            justify-content: space-between;
            
            .item{
                .w(280);
                .h(128);
                margin-bottom: 8rem;
                position: relative;
                .img{
                    width: 100%;
                    height: 100%;
                }
                .all{
                    position: absolute;
                    text-align: right;
                    color: #ffffff;
                    bottom: 10px;
                    right: 10px;
                    font-size: 26rem;
                    padding: 0 10rem;
                    text-align: right;
                    cursor: pointer;
                    img{
                        vertical-align: -5px;
                        margin-right: 10px;
                    }
                }
                .inall{
                    position: absolute;
                    background: rgba(66, 66, 66, 0.4);
                    width: 100%;
                    height: 30rem;
                    line-height: 30rem;
                    text-align: right;
                    color: #ffffff;
                    bottom: 0;
                    left: 0;
                    font-size: 16rem;
                    padding: 0 10rem;
                    text-align: right;
                    span{
                        cursor: pointer;
                    }
                    img{
                        width: 14px;
                        height: 14px;
                        vertical-align: -2rem;
                        margin-right: 5rem;
                    }
                }
            }
            .novideo{
                text-align: center;
                background: rgba(0, 43, 102, 0.04);
                line-height: 11vh;
                img{
                    vertical-align: middle;
                }
            }
            .full{
                width: 100vw;
                height: 100vh;
                position: fixed;
                top: 0;
                left: 0;
                z-index: 9999;
            }
        }
    }
</style>